import { isRouteErrorResponse, useRouteError } from 'react-router'

import { paths } from '@/app/router/paths.ts'
import { Button } from '@/components/ui/button.tsx'

function describe(error: unknown): string {
  if (isRouteErrorResponse(error)) {
    return `${String(error.status)} ${error.statusText}`
  }
  if (error instanceof Error) {
    return error.message
  }
  return 'Неизвестная ошибка'
}

/** Catches render/loader errors so a single broken route cannot blank the app. */
export function RouteErrorBoundary() {
  const error = useRouteError()

  return (
    <div className="mx-auto flex min-h-dvh max-w-2xl flex-col items-start gap-4 bg-background px-4 py-8">
      <h1 className="text-[28px] leading-8 font-bold tracking-tight">Что-то пошло не так</h1>
      <p className="text-base text-muted-foreground">{describe(error)}</p>
      <Button asChild size="touch">
        <a href={paths.home}>На главную</a>
      </Button>
    </div>
  )
}
